import { type FunctionComponent } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';

import { CLASS_NAMES, PLACEHOLDER_TEXT } from './constants';
import { DocumentPdfProps } from './types';
import useOmniSignDocumentsFormBasePageDocument from './useOmniSignDocumentsFormBasePageDocument';

import { BaseDocument } from '../useOmniSignDocumentsFormBasePage';

interface OmniSignDocumentsFormBasePageDocumentProps {
  document?: BaseDocument;
}

const OmniSignDocumentsFormBasePageDocument: FunctionComponent<
  OmniSignDocumentsFormBasePageDocumentProps
> = ({ document }) => {
  const { showContent, pdfProps, pages } =
    useOmniSignDocumentsFormBasePageDocument(document);
  return (
    <div className="flex flex-col">
      <div className={CLASS_NAMES.documentContainer}>
        <div className={CLASS_NAMES.documentPadding}>
          {showContent ? (
            <Document
              {...(pdfProps as DocumentPdfProps)}
              className={CLASS_NAMES.document}
            >
              {pages && pages.map((page) => <Page key={page.key} {...page} />)}
            </Document>
          ) : (
            <p className="mx-auto mt-6 text-center max-w-60 text-16-20">
              {PLACEHOLDER_TEXT}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default OmniSignDocumentsFormBasePageDocument;
